/**
 * @ngdoc Controller
 * @name EmbedController
 */
(function () {
    'use strict';

    angular.module('vrm.core')
        .controller('EmbedController', EmbedController);

    /**
     * @constructor
     * @ngInject
     */
    function EmbedController(localStorageService, $q, $log, $state, $rootScope, $scope, $stateParams, InstallationsService, ApiService, $timeout, $document, vrmNotificationsService, vrmNotificationType, $filter, locale) {
        $log.info('EmbedController');

        $scope.authenticated = false;
        $scope.found = false;

        var data = {
            token: $stateParams.token,
            idSite: $stateParams.id
        };

        $q.all([
            ApiService.verifyEmbed(data),
        ]).then(openInstallation, error);

        function openInstallation(response) {
            response = response[0];
            if (response.data.success === true) {
                localStorageService.set("token", response.data.token);
                $scope.authenticated = true;
                $rootScope.$emit('login');
                $scope.$watchCollection('installations', function () {
                    InstallationsService.getInstallation($stateParams.id).then(function (installation) {
                        if (installation) {
                            $scope.installation = installation;
                            InstallationsService.setRealtimeInstallation(installation);
                            $rootScope.viewTitle = installation.name;
                            $scope.found = true;
                        } else {
                            error();
                        }
                    });
                });
            }
        }

        function error() {
            locale.ready('share').then(function () {
                vrmNotificationsService.add({
                    type: vrmNotificationType.ERROR,
                    message: locale.getString('share.embed_open_failed'),
                    timeout: 60 * 1000
                });
            });
        }
    }
})();
